var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.crediti !== undefined && _vm.crediti !== null
    ? _c(
        "span",
        {
          staticClass: "crediti",
          class: [_vm.variantClass, { "crediti-glow": _vm.glow }],
        },
        [
          _vm.useIcon
            ? _c(
                "v-icon",
                { staticClass: "crediti-icon", attrs: { small: "", left: "" } },
                [_vm._v(_vm._s(_vm.icon))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.crediti))]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }